<template>
  <div class="wrapper-content w-100">
    <h2 v-if="itemDetail.customListTitle">{{ itemDetail.customListTitle }}</h2>
    <h2 v-else>{{ title }}</h2>
    <LmComponentLoading v-if="isLoading" fixed />
    <LmBreadcrumb v-if="showBreadcrumb" />
    <div v-if="!isLoading" id="printContainer">
      <div class="detalle-nomenclatura">
        <div class="row">
          <div class="col-9 seccion-detalle">
            <div class="row">
              <div class="col-4">
                <div v-if="itemDetail.encabezadoNomenclatura.tipo">
                  <span class="font-weight-bold">TIPO:</span>
                  {{itemDetail.encabezadoNomenclatura.tipo}}
                </div>
              </div>
              <div class="col-8">
                <div v-if="itemDetail.encabezadoNomenclatura.seccion">
                  <span class="font-weight-bold">SECCION:</span>
                  {{itemDetail.encabezadoNomenclatura.seccion}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div v-if="itemDetail.encabezadoNomenclatura.contribuyente">
                  <span class="font-weight-bold">CONTRIBUYENTE:</span>
                  {{itemDetail.encabezadoNomenclatura.contribuyente}}
                </div>
              </div>
              <div class="col-3">
                <div v-if="itemDetail.encabezadoNomenclatura.cuenta">
                  <span class="font-weight-bold">CUENTA:</span>
                  {{itemDetail.encabezadoNomenclatura.cuenta}}
                </div>
              </div>
              <div class="col-3">
                <div v-if="itemDetail.encabezadoNomenclatura.dni">
                  <span class="font-weight-bold">DNI:</span>
                  {{itemDetail.encabezadoNomenclatura.dni}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-if="itemDetail.encabezadoNomenclatura.domicilio">
                  <span class="font-weight-bold">DOMICILIO:</span>
                  {{itemDetail.encabezadoNomenclatura.domicilio}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="seccion-estados">
              <p class="text-center">
                {{itemDetail.encabezadoNomenclatura.estado}}
              </p>
              <p class="text-center">
                VTO: {{itemDetail.encabezadoNomenclatura.fechaVencimiento}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="seccion-inhumados">
        <div v-for="(item, index) in itemDetail.detalleInhumados" :key="index" class="inhumado">
          <div class="row">
            <div class="col-12">
              <div class="encabezado font-weight-bold">{{item.fallecido}}</div>
            </div>
          </div>
          <div class="row">
            <div v-if="item.fechaInhumacion" class="col-4">
              <span class="font-weight-bold">Fecha Inhumacion:</span>
              {{item.fechaInhumacion}}
            </div>
            <div v-if="item.registro" class="col-4">
              <span class="font-weight-bold">Registro:</span>
              {{item.registro}}
            </div>
            <div v-if="item.orden" class="col-4">
              <span class="font-weight-bold">Orden:</span>
              {{item.orden}}
            </div>
          </div>
          <div v-if="item.detalleNomenclaturaInhumado.rows.length > 0" class="row detalle">
            <LmTable
              :content="item.detalleNomenclaturaInhumado"
              :showHeaderTable="true"
              :hideHeadersBelowRows="true"
              >
            </LmTable>
          </div>
        </div>
      </div>
      <div class="seccion-ctacte row">
        <LmTable class="seccion-ctacte"
          :content="itemDetail.detalleCtacte"
          :showHeaderTable="true"
          :hideHeadersBelowRows="true"
          >
        </LmTable>
      </div>
    </div>
    <form
      @submit.prevent="submit"
      novalidate
      class="position-relative actions">
      <LmButton
        v-if="showPDFButton"
        type="button"
        @click.native="print()"
        :value="$t('print')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        @click.native="goBackBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        />
    </form>
  </div>
</template>

<script>
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  computed: {
    ...mapState('commons', ['itemDetail']),
    apiCall () {
      return {
        path: this.newOrEditEndpointUri,
        id: this.$route.params.id
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    showPDFButton: {
      type: Boolean,
      required: false,
      default: false
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true
    }
  },
  methods: {
    ...mapActions('commons', ['getItemDetail']),
    goBackBtn () {
      this.$router.push(this.onSuccessDestinationRoute)
    },
    print () {
      const prevTitle = document.title
      document.title = `nomenclatura-${this.itemDetail.cuenta}`
      this.$htmlToPaper('printContainer')
      document.title = prevTitle
    }
  },
  created () {
    (async () => {
      await this.getItemDetail(this.apiCall)
        .catch(error => {
          console.log(error)
          this.$router.replace({ name: '404' })
        })
      this.isLoading = false
    })()
  }
}
</script>
<style lang="sass" scoped>
  .detalle-nomenclatura
    background-color: #e9ecef
    margin-top: 20px
    margin-bottom: 10px
    .seccion-detalle
      padding: 10px
      padding-left: 30px
    .seccion-estados
      height: 100%
      background-color: #007bff
      color: white
      padding-top: 10px
  .seccion-inhumados
    margin-top: 40px
    .inhumado
      margin-top: 30px
      .encabezado
        background-color: #e9ecef
        padding: 10px
        margin-bottom: 10px
      .detalle
        margin-top: 20px
        margin-bottom: 20px
  .actions
    margin-top: 40px
</style>
